module.exports = __webpack_public_path__ + "img/5.925fbe99.jpg";